import * as CONST from '../ActionTypes';

const initialState = {
  invoiceHistoryList: [],
  invoiceHistoryTransferList: [],
  invoiceHistory: {},
  invoiceDraftList: [],
  query: {
    currentPage: 0,
    itemsPerPage: 10,
    sort: 'created_at',
    isAsc: false,
    search: '',
    transferDueFrom: '',
    transferDueTo: '',
  },
  isSuccess: false,
};

function invoice(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 請求書発行履歴一覧取得
    // -----------------
    case CONST.GET_INVOICE_HISTORY_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          invoiceHistoryList: action.payload,
        },
      );
    case CONST.GET_INVOICE_HISTORY_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          invoiceHistoryList: [],
        },
      );
    case CONST.SET_INVIOCE_DETAIL:
      return Object.assign(
        {},
        state,
        {
          invoiceHistory: action.payload,
        },
      );
    // -----------------
    // queryパラメータの設定
    // -----------------
    case CONST.SET_INVOICE_QUERY:
      return Object.assign(
        {},
        state,
        {
          query: action.payload,
        },
      );
    // -----------------
    // 請求書下書き一覧取得
    // -----------------
    case CONST.GET_INVOICE_DRAFT_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          invoiceDraftList: action.payload,
        },
      );
    case CONST.GET_INVOICE_DRAFT_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          invoiceDraftList: {},
        },
      );
    // -----------------
    // 請求書口座振替
    // -----------------
    case CONST.GET_INVOICE_HISTORY_TRANSFER_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          invoiceHistoryTransferList: action.payload,
        },
      );
    case CONST.GET_INVOICE_HISTORY_TRANSFER_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          invoiceHistoryTransferList: [],
        },
      );
    // -----------------
    // 請求書下書き一覧取得
    // -----------------
    case CONST.DELETE_INVOICE_DRAFT_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
        },
      );
    case CONST.CLEAR_DELETE_INVOICE_DRAFT_RESULT:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
        },
      );

    default:
      return state;
  }
}

export default invoice;
